// extracted by mini-css-extract-plugin
export default {"link":"UN-z","disabled":"VN-z"};